import { initialTableShow } from 'utils/settings';

export const mainTableConf = [
  {
    isSortable: true,
    field: 'companyName',
    title: 'Company Name',
    show: true,
    width: 417,
    valuesExport: [
      'companyName',
      'customerId',
      'status',
      'companySize',
      'country',
      'partnerType',
      'customerType',
      'website'
    ]
  },
  {
    isSortable: false,
    field: 'nextQbrDate',
    title: 'Next QBR Date',
    show: true,
    width: 172,
    valuesExport: ['nextQbrDate']
  },
  {
    isSortable: true,
    field: 'occurredDate',
    title: 'Occurred Date',
    show: true,
    width: 172,
    valuesExport: ['occurredDate']
  },
  {
    isSortable: false,
    field: 'opportunityId',
    title: 'Opportunity Id',
    show: true,
    width: 172,
    valuesExport: ['opportunityId']
  },
  {
    isSortable: true,
    field: 'sentiment',
    title: 'Sentiment',
    show: true,
    width: 132,
    valuesExport: ['sentiment']
  },
  {
    isSortable: false,
    field: 'customerFeedback',
    title: 'Feedback',
    show: true,
    width: 382,
    valuesExport: ['customerFeedback']
  },
  {
    isSortable: true,
    field: 'accountManager',
    title: 'Acc. Manager',
    show: true,
    width: 154,
    valuesExport: ['accountManager']
  },
  {
    isSortable: true,
    field: 'customerSuccessEngineer',
    title: 'CS Engineer',
    show: true,
    width: 154,
    valuesExport: ['customerSuccessEngineer']
  }
];

export const exportConfigQbr = {
  exportUrl: '/qbr/export',
  exportName: 'qbrs',
  exportFormat: 'zip'
};

export const defaultFilters = {
  search: '',
  occurredDate: { startDate: null, endDate: null },
  accountManager: [],
  customerSuccessEngineer: [],
  sentiment: []
};

export const defaultNavigation = {
  fieldName: 'occurredDate',
  direction: initialTableShow.direction,
  currentPage: initialTableShow.currentPage,
  itemsPerPage: initialTableShow.itemsPerPage
};

export const chartColor = {
  closed: '#4dc9f6',
  hold: '#ac89f3',
  open: '#ff829d',
  pending: '#fbdf9c',
  solved: '#6fcdcd'
};
